/**
 * @generated SignedSource<<de92f2d86120b59b3c2c8ae8ad32f7c6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "VibePost",
    "kind": "LinkedField",
    "name": "likeVibePost",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "likesCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "likedByCurrentUser",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "likeButtonLikeVibePostMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "likeButtonLikeVibePostMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b8229149beb7b78f09bb91b2b214d7d9",
    "id": null,
    "metadata": {},
    "name": "likeButtonLikeVibePostMutation",
    "operationKind": "mutation",
    "text": "mutation likeButtonLikeVibePostMutation(\n  $request: LikeVibePostRequestInput!\n) {\n  likeVibePost(request: $request) {\n    id\n    likesCount\n    likedByCurrentUser\n  }\n}\n"
  }
};
})();

node.hash = "2de191a60b85c5f02804862f61938f22";

module.exports = node;
